// extracted by mini-css-extract-plugin
export default {"tag":"BManualTag-module_tag_b6fad8dd"};